import { __decorate } from "tslib";
import { Options, Vue } from "vue-class-component";
import SingleWorkItem from "@/components/SingleWorkItem.vue";
import Pagination from "@/components/shared/Pagination.vue";
let PortfolioComp = class PortfolioComp extends Vue {
    portfolios;
};
PortfolioComp = __decorate([
    Options({
        props: {
            portfolios: String,
        },
        components: {
            SingleWorkItem,
            Pagination,
        },
        data() {
            return {
                currentPage: 0,
                pageSize: 6,
                PageItems: [],
            };
        },
        methods: {
            updatePageItems() {
                this.PageItems = this.portfolios.slice(this.currentPage * this.pageSize, this.currentPage * this.pageSize + this.pageSize);
                if (this.PageItems.length == 0 && this.currentPage > 0) {
                    this.updatePage(this.currentPage - 1);
                }
            },
            getDataFromStorage(str) {
                return localStorage.getItem(str);
            },
            updatePage(pageNum) {
                this.currentPage = pageNum;
                this.updatePageItems();
            },
        },
        mounted() {
            // console.log(" mounted");
            this.updatePageItems();
        },
        computed: {
            site_data() {
                return this.$store.state.site_data;
            },
        },
    })
], PortfolioComp);
export default PortfolioComp;
